import Layout from '../views/layout/App.vue'
import Empty from '../views/layout/Empty.vue'
export default {
    path: '/merchandise_manage',
    name: 'Merchandise',
    meta: {
        title: '商品管理',
        isAdmin: true
    },
    component: Layout,
    redirect: '/merchandise_manage/merchandise',
    children: [
        {
            path: 'merchandise',
            name: 'Merchandise',
            meta: {
                title: '商品列表',
                isAdmin: true
            },
            component: resolve => require(['@/views/merchandiseManage/merchandise/Index.vue'], resolve),
        },
        {
            path: 'merchandise',
            meta: {
                title: '商品列表',
                isAdmin: true
            },
            component:Empty,
            children: [
                {
                    path: 'create_new_merchandise',
                    name: 'createNewMerchandise',
                    meta: {
                        title: '包装商品',
                        isAdmin: true
                    },
                    component: resolve => require(['@/views/merchandiseManage/createNewMerchandise/Index.vue'], resolve),
                },
                {
                    path: 'update_merchandise',
                    name: 'updateMerchandise',
                    meta: {
                        title: '修改商品',
                        isAdmin: true
                    },
                    component: resolve => require(['@/views/merchandiseManage/createNewMerchandise/Index.vue'], resolve),
                },
                {
                    path: 'preview_merchandise',
                    name: 'previewMerchandise',
                    meta: {
                        title: '预览商品',
                        isAdmin: true
                    },
                    component: resolve => require(['@/views/merchandiseManage/merchandise/previewMerchandise.vue'], resolve),
                },
            ]
        },
    ]
}
